<template>
  <div>
    <div class="row">
      <div class="col-sm-12">
        <h1>
          Dry Cow Consult {{ getDairySeasonStartYear }} <span v-if='currentClientName'>- {{currentClientName}}</span>
        </h1>
      </div>
    </div>

    <loader v-if="isLoadingApi"></loader>

    <template  v-if="dataFetched">
      <consult-opened-by-other-warning></consult-opened-by-other-warning>
      <consult-backend-errors store-namespace="currentConsult"></consult-backend-errors>

      <consult-navigation></consult-navigation>

      <div class="row">
        <div :class="[showVetNotes ? 'col-xs-9' : 'col-xs-12']">
          <vet-notes-toggle style="position: absolute; top: 30px; right: 20px">
          </vet-notes-toggle>
          <component :is="currentComponent" :key="currentComponent">
          </component>
        </div>

        <div class="col-xs-3" v-show="showVetNotes" style="position: sticky; top: 200px; z-index: 3">
          <div style="display: flex; flex-direction: column">
            <vet-notes field-name="vet_notes"
              model-name="ClientDetails"
              email-notification="dc-vet-notes"
              v-show="showVetNotes">
            </vet-notes>
            <br />
            <br />
            <farm-services-notes
              field-name="notes_for_farm_services"
              model-name="ClientDetails"
              email-notification="notes-for-farm-services"
            >
            </farm-services-notes>
          </div>
        </div>
      </div>

      <consult-navigation v-on:step-changed="scroll()" placement="top"></consult-navigation>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import { dryCowConsultComponents } from '@/components/dry_cow_consult'

import currentConsult from "@/_store/current_consult.module";
import dryCowConsult from '@/_store/dry_cow_consult.module';

import ConsultBackendErrors from '@/components/ConsultBackendErrors'
import ConsultNavigation from "@/components/ConsultNavigation"
import ConsultOpenedByOtherWarning from "@/components/ConsultOpenedByOtherWarning"
import VetNotes from "@/components/VetNotes"
import VetNotesToggle from "@/components/VetNotesToggle"
import FarmServicesNotes from '@/components/FarmServicesNotes'
import { scrollToTop } from '@/_helpers'
import _ from 'lodash';

export default {
  components: {
    ...dryCowConsultComponents,
    ConsultBackendErrors,
    ConsultNavigation,
    ConsultOpenedByOtherWarning,
    FarmServicesNotes,
    VetNotes,
    VetNotesToggle,
  },
  data () {
    return {
      isLoadingApi: false,
      dataFetched: false,
    }
  },
  created() {
    Object.assign(currentConsult.state, dryCowConsult.stateMixin);
    Object.assign(currentConsult.actions, dryCowConsult.actionsMixin);
    Object.assign(currentConsult.mutations, dryCowConsult.mutationsMixin);
    Object.assign(currentConsult.getters, dryCowConsult.gettersMixin);

    if (this.$store.hasModule("currentConsult")) {
      this.$store.unregisterModule("currentConsult")
    }

    this.$store.registerModule("currentConsult", currentConsult);
    this.setCurrentConsultClient(this.$route.params.client_id)
    this.setCurrentConsultType('dryCowConsult')
  },
  beforeDestroy()
  {
    this.backupState()
  },
  mounted() {
    this.setClient(this.$route.params.client_id)
    let readOnly = Boolean(this.$route.params.history)
    this.fetchData(readOnly)
  },
  watch: {
    '$store.state': {
    handler: _.debounce(function () {
      this.backupState()
    }, 2000),
    deep: true
    }
  },
  methods: {
    ...mapMutations('currentConsult', {
      setCurrentConsultClient: 'setClient',
      setCurrentConsultType: 'setConsultType',
    }),
    ...mapActions('currentConsult', [
      'backupState',
      'getConsultData',
      'getReadOnlyData',
      'setClient',
    ]),
    scroll()
    {
      scrollToTop()
    },
    fetchData(readOnly) {

      this.isLoadingApi = true

      let consultParams = {
        clientId: this.$route.params.client_id,
        season: this.$route.params.season,
      }

      let action = readOnly ? this.getReadOnlyData : this.getConsultData

      action(consultParams)
        .then(() => {
          this.dataFetched = true
        })
        .catch((error) => {
          if ( error.response.data['no_active_farms'] ) {
            this.$store.dispatch('alert/error', {
              message: 'The dairy consult could not be created because this client does not have a valid dairy shed herd registered in KVC.  Please contact farm services to resolve this issue.',
              persist: true
            });
          } else {
          this.$store.dispatch('alert/error', {
            message: 'An error occurred. Contact the administrator.',
            persist: true
          });
          }
          this.$router.push('/')
        })
        .finally(() => {
          this.isLoadingApi = false
        })
    },
  },
  computed: {
    ...mapState('currentConsult', ['showVetNotes']),
    ...mapGetters('currentConsult', [
      'currentComponent',
      'currentClientName',
			'consultOpenedDate'
    ]),
    getDairySeasonStartYear: function() {
			return this.consultOpenedDate
				? this.$moment(this.consultOpenedDate).format("DD MMM Y")
				: "";
    },
  },
};
</script>

<style>
.farm-fields-xl {
  width: 500px;
}

div.step-section {
  margin: 50px 5px;
}

h2.step-name {
  color: #337ab7;
  text-decoration: underline;
}

div.comments {
  margin: 20px;
}

</style>
